import qs from 'query-string'

/**
 * Represents an explorer request
 */
class Request {
  constructor(explorer) {
    this.explorer = explorer
  }

  /**
   * Initializes the verb, URL, query, body
   * and headers
   */
  async init() {
    this.initVerb()
    this.initPath()
    this.initQuery()
    this.initBody() 
    await this.initHeaders()
  }

  /**
   * Actually makes the API call
   */
  async call() {
    const request = {
      method: this.verb,
      headers: await this.headers
    }

    if (this.hasBody) {
      request.body = this.body
    }

    try {
      let response = await fetch(this.path, request)
      return response
    } catch(err) {
      // eslint-disable-next-line
      console.error(err)
      return null
    }
  }

  // PRIVATE

  /**
   * Determines the full URL for the API call,
   * replacing any variables
   */
  initPath() {
    const { server: { url }, path } = this.explorer.endpoint
    this.path = `${url}${path}`

    const entries = Object.entries(this.explorer.values.path)
    entries.forEach(([key, value]) => {
      this.path = this.path.replace(`{${key}}`, value)
    })
  }

  /**
   * Initializes the verb
   */
  initVerb() {
    this.verb = this.explorer.endpoint.verb.toUpperCase()
  }

  /**
   * Appends the query to the full url
   */
  initQuery() {
    const query = qs.stringify(this.explorer.values.query)
    if (query.length) {
      this.path = `${this.path}?${query}`
    }
  }

  /**
   * Serializes the body
   */
  initBody() {
    const validVerb = !['GET', 'OPTIONS'].includes(this.verb)
    const emptyBody = Object.keys(this.explorer.values.body).length === 0
    this.hasBody = validVerb && !emptyBody

    if (this.hasBody) {
      this.body = JSON.stringify(this.explorer.values.body)
    }
  }

  /**
   * Initializes all the headers for the API call
   */
  async initHeaders() {
    this.headers = {
      'Authorization': `Bearer ${await this.explorer.accessToken.token()}`
    }

    const entries = Object.entries(this.explorer.values.header)
    entries.forEach(([key, value]) => {
      this.headers[key] = value
    })
  }
}

export default Request